import { Observable, Subject } from "rxjs";
import { SimpleValidation } from "./simple-validation.model";
import { CustomValidation } from "./custom-validation.model";

export class VisibleOn {

    // validationType?: 'equal' | 'not-equal' | 'less-than' | 'greater-than' | 'contains';
    // value?: any;
    // valueProperty?: string;
    // controlAlias?: string;
    // visibleSubject = new Subject<boolean>();
    
    simpleValidation?: SimpleValidation;
    customValidation?: CustomValidation;
    isCustomValidation?: boolean;
    clearFieldValidations?: boolean;

    constructor(source: Partial<VisibleOn>) {
        this.isCustomValidation = false;
        Object.assign(this, source);
    }

    // setVisibleObservable(): Observable<boolean> {
    //     return this.visibleSubject.asObservable();
    // }

    // validateVisible(value: any) {

    //     let response: boolean = false;

    //     if (!this.isCustomValidation) {
    //         response = this.simpleValidation?.validate(value)!;
    //     }


    //     switch (this.validationType) {
    //         case "equal":
    //             response = this.value == value;
    //             break;
    //         case "not-equal":
    //             response = this.value !== value;
    //             break;
    //         case "greater-than":
    //             response = this.value > value;
    //             break;
    //         case "less-than":
    //             response = this.value < value;
    //             break;
    //         case "contains":
    //             response = this.value.includes(value);
    //             break;
    //     }

    //     this.visibleSubject.next(response);
    // }
}